import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Grid, Stack, Typography, IconButton } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';
import { YES_NO } from '../../../../../constants';

export const MenustralHistory = ({ onAdd, onClose, setMenustralHistoryDialog }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        previous_cycle: Yup.string().required(' ')
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;

  const formSubmit = (formValue) => {
    onAdd(formValue);
    setMenustralHistoryDialog(false);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ borderBottom: 1, borderColor: 'grey.300', paddingBottom: 2 }}>
        <Typography variant="h4" fontWeight="bold" sx={{ marginBottom: "2%", fontSize: "1.5rem", color: "#333" }}>
          Menstrual History
        </Typography>
        <IconButton onClick={onClose} sx={{ color: 'red' }}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </Stack>

      <Grid container spacing={2} sx={{ marginTop: 3 }}>
        <Grid item xs={12} sm={6}>
          <Stack spacing={2}>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Previous Cycle</Typography>
              <TextField sx={{ flex: 1 }} name="previous_cycle" placeholder="Previous Cycle" variant="outlined" />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Present Cycle</Typography>
              <TextField sx={{ flex: 1 }} name="present_cycle" placeholder="Present Cycle" variant="outlined" />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Dysmenorrhea Type</Typography>
                  <TextField sx={{ flex: 1 }} name="dysmenorrhea_type" variant="outlined" />
                </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Last Menstrual Date</Typography>
              <TextField sx={{ flex: 1 }} name="last_menustral_date" placeholder="Last Menstrual Date" type="date" variant="outlined" />
            </Stack>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Stack spacing={2}>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Cycle Type</Typography>
              <TextField sx={{ flex: 1 }} name="previous_cycle_type" placeholder="Previous Cycle Type" variant="outlined" />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.55, fontWeight: 600, fontSize: '1.2rem' }}>Cycle Type</Typography>
              <TextField sx={{ flex: 1 }} name="present_cycle_type" placeholder="Present Cycle Type" variant="outlined" />
              <Typography sx={{ flex: 0.1, fontWeight: 600, fontSize: '1.2rem' }}>Days</Typography>
              <TextField sx={{ flex: 0.2 }} name="days" placeholder="Days" variant="outlined" />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Dysmenorrhea</Typography>
                  <SelectTag formControlSX={{ flex: 1 }} name="dysmenorrhea" menus={YES_NO} />
                </Stack>
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Stack spacing={2}>
            {/* Properly aligned Dysmenorrhea and Dysmenorrhea Type */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
           
              </Grid>
            </Grid>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.15, fontWeight: 600, fontSize: '1.2rem' }}>Details</Typography>
              <TextField sx={{ flex: 1 }} name="details" multiline rows={4} variant="outlined" />
            </Stack>
          </Stack>
        </Grid>
      </Grid>

      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" sx={{ marginTop: 3 }}>
        <Button variant="contained" type="submit"  >
          Add
        </Button>
        <Button color="error" onClick={onClose} >
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
